import React from "react";
import { useTheme } from "styled-components";

import { RemoteComponentWrapper } from "./RemoteComponentWrapper";

const RemoteForgeNarrativeSelector = React.lazy(
    () => import("adsForgeMfc/NarrativeSelector"),
) as React.FC<any>;

export const ForgeNarrativeSelector: React.FC<any> = (props) => {
    const theme = useTheme();

    return (
        <RemoteComponentWrapper>
            <RemoteForgeNarrativeSelector {...props} theme={theme} />
        </RemoteComponentWrapper>
    );
};
